// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("resources/images/templates/new-and-notable.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.O8ZFPXEf8csMK9 {
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-start;
  width: 100%;
  margin-top: 24px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  -webkit-transform: translate3d(0, 0, 0);
  scrollbar-color: var(--ds-background-neutral-hovered, #091e4224) var(--ds-background-neutral, #091e420f);
  scrollbar-width: thin;
}
.O8ZFPXEf8csMK9::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
.O8ZFPXEf8csMK9::-webkit-scrollbar-button:start:decrement,
.O8ZFPXEf8csMK9::-webkit-scrollbar-button:end:increment {
  display: none;
  background: transparent;
}
.O8ZFPXEf8csMK9::-webkit-scrollbar-track-piece {
  background: var(--ds-background-neutral, #091e420f);
}
.O8ZFPXEf8csMK9::-webkit-scrollbar-track-piece:vertical:start {
  border-radius: 4px 4px 0 0;
}
.O8ZFPXEf8csMK9::-webkit-scrollbar-track-piece:vertical:end {
  border-radius: 0 0 4px 4px;
}
.O8ZFPXEf8csMK9::-webkit-scrollbar-track-piece:horizontal:start {
  border-radius: 4px 0 0 4px;
}
.O8ZFPXEf8csMK9::-webkit-scrollbar-track-piece:horizontal:end {
  border-radius: 0 4px 4px 0;
}
.O8ZFPXEf8csMK9::-webkit-scrollbar-thumb:vertical,
.O8ZFPXEf8csMK9::-webkit-scrollbar-thumb:horizontal {
  display: block;
  height: 48px;
  border-radius: 4px;
  background: var(--ds-background-neutral-hovered, #091e4224);
}
.qXXB5a80X9YQEh {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  width: 100%;
  margin-top: 24px;
}
.NyKf7YOIfnAUv9 {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.NyKf7YOIfnAUv9::-webkit-scrollbar {
  display: none;
}
.qvvpTPsTewc5G1 {
  display: flex;
  align-items: center;
  margin-top: 6px;
  margin-bottom: 6px;
}
.qvvpTPsTewc5G1 .GXKgEapHdSThEH {
  display: inline-block;
  width: 24px;
  min-width: 24px;
  height: 24px;
  margin-right: 12px;
  border-radius: 3px;
}
.qvvpTPsTewc5G1 .P9hXYkmpLJ8zYG {
  background-color: var(--ds-background-accent-yellow-subtle, #e2b203);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.qvvpTPsTewc5G1 .AxjWbPpRpHFLNO {
  margin-bottom: 0;
  font-size: 20px;
  line-height: 24px;
}
.qvvpTPsTewc5G1 .CIe3SZyehVRUpa {
  margin-left: auto;
}
.qvvpTPsTewc5G1 .CIe3SZyehVRUpa:focus {
  border: none;
  outline: 0;
  background-color: var(--ds-background-neutral-pressed, #091e424f);
  box-shadow: none;
  color: var(--ds-text, #172b4d);
}
.qvvpTPsTewc5G1 .CIe3SZyehVRUpa:focus .A5swPzhpPWEXvb {
  color: var(--ds-text, #172b4d);
}
.qvvpTPsTewc5G1 .CIe3SZyehVRUpa:focus svg circle {
  stroke: var(--ds-text, #172b4d);
}
.qvvpTPsTewc5G1 .N0y1arGTrlPbi7 {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
@media only screen and (min-width: 751px) and (max-width: 900px), only screen and (max-width: 750px), only screen and (max-width: 600px) {
  .qvvpTPsTewc5G1 .N0y1arGTrlPbi7 {
    flex-direction: column-reverse;
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"categoryTilesContainer": `O8ZFPXEf8csMK9`,
	"templatesTilesContainer": `qXXB5a80X9YQEh`,
	"hideScrollbars": `NyKf7YOIfnAUv9`,
	"headerContainer": `qvvpTPsTewc5G1`,
	"headerIcon": `GXKgEapHdSThEH`,
	"newAndNotableIcon": `P9hXYkmpLJ8zYG`,
	"templateGalleryHeader": `AxjWbPpRpHFLNO`,
	"moreTemplatesCategoryLink": `CIe3SZyehVRUpa`,
	"icon-sm": `A5swPzhpPWEXvb`,
	"featuredContainer": `N0y1arGTrlPbi7`
};
export default ___CSS_LOADER_EXPORT___;
